import { mapMutations, mapGetters } from "vuex";
import {} from "@/store/mutation-types";

export default {
    name: "article-item",
    props: ["article"],
    computed: {
        ...mapGetters({}),
    },
    methods: {
        ...mapMutations({}),
    },
};
